export default [
  {
    path: window.pathApp + '/area-do-filiado',
    name: 'area.filiado',
    component: () => import('@/components/AreaFiliado'),
    meta: {
      login: true,
      avisoCarrinho: false,
      title: "Área do Filiado",
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/area_filiado.js